import React, { useState, useRef } from "react";
import "../../../../../Assets/Styles/SearchInput.scss";

const SearchInput = (props) => {
  const SearchRef = useRef(null);
  const [PlaceholderIsShown, setPlaceHolderShown] = useState(true);

  const addActiveState = () => {
    document.getElementById("search-icon").classList.add("search-active-icon");
  };
  const removeActiveState = () => {
    document
      .getElementById("search-icon")
      .classList.remove("search-active-icon");
  };

  const handleInputChange = () => {
    let Value = document.getElementById("search-input").value;
    if (Value.length > 0) {
      setPlaceHolderShown(false);
    } else {
      setPlaceHolderShown(true);
    }
    if (SearchRef.current) {
      clearTimeout(SearchRef.current);
    }

    SearchRef.current = setTimeout(() => {
      props.OnChange();
    }, 1500);
  };

  const clearSearch = () => {
    document.getElementById("search-input").value = "";
    setPlaceHolderShown(true);
    document.getElementById("clear-btn").classList.add("hidden");
    document.getElementById("search-placeholder").classList.remove("hidden");
    document.getElementById("search-placeholder").style.display = "unset";
    props.OnChange();
  };
  return (
    <div
      className={
        props.ClassName ? "search-wrapper " + props.ClassName : "search-wrapper"
      }
    >
      <input
        onFocus={() => addActiveState()}
        onBlur={() => removeActiveState()}
        onChange={() => handleInputChange()}
        className="search-input"
        id="search-input"
        autoComplete="off"
      />
      <i id="search-icon" className="feather-search"></i>
      <p className={PlaceholderIsShown ? "" : "hidden"} id="search-placeholder">
        {props.Placeholder}
      </p>
      <i
        onClick={() => clearSearch()}
        className={
          PlaceholderIsShown ? "feather-x-circle hidden" : "feather-x-circle"
        }
        id="clear-btn"
      ></i>
    </div>
  );
};

export default SearchInput;
